import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal bg-white fade",
  id: "kt_header_search_modal",
  "data-bs-backdrop": "false",
  "aria-hidden": "true",
  ref: "searchModalRef"
}
const _hoisted_2 = { class: "modal-dialog modal-fullscreen" }
const _hoisted_3 = { class: "modal-content shadow-none" }
const _hoisted_4 = { class: "container w-lg-800px" }
const _hoisted_5 = { class: "modal-header d-flex justify-content-end border-0" }
const _hoisted_6 = {
  class: "btn btn-icon btn-light-primary ml-2",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "modal-body" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("form", {
  class: "pb-10",
  action: "",
  method: ""
}, [
  /*#__PURE__*/_createElementVNode("input", {
    type: "text",
    class: "form-control bg-transparent border-0 fs-4x text-center fw-normal",
    name: "query",
    placeholder: "Search..."
  })
], -1)
const _hoisted_10 = { class: "py-10" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder mb-8" }, "Shop Goods", -1)
const _hoisted_12 = { class: "row g-5" }
const _hoisted_13 = { class: "col-sm-6" }
const _hoisted_14 = { class: "row g-5" }
const _hoisted_15 = { class: "col-sm-6" }
const _hoisted_16 = { class: "card card-custom overlay min-h-125px mb-5 shadow-none" }
const _hoisted_17 = { class: "card-body d-flex flex-column p-0" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", {
  class: "overlay-wrapper flex-grow-1 bgi-no-repeat bgi-size-cover bgi-position-center card-rounded",
  style: {"background-image":"url('media/stock/600x400/img-17.jpg')"}
}, null, -1)
const _hoisted_19 = { class: "overlay-layer bg-white bg-opacity-50" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Explore")
const _hoisted_21 = { class: "card card-custom overlay min-h-125px mb-5 shadow-none" }
const _hoisted_22 = { class: "card-body d-flex flex-column p-0" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", {
  class: "overlay-wrapper flex-grow-1 bgi-no-repeat bgi-size-cover bgi-position-center card-rounded",
  style: {"background-image":"url('media/stock/600x400/img-1.jpg')"}
}, null, -1)
const _hoisted_24 = { class: "overlay-layer bg-white bg-opacity-50" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Explore")
const _hoisted_26 = { class: "col-sm-6" }
const _hoisted_27 = { class: "card card-custom card-stretch overlay mb-5 shadow-none min-h-250px" }
const _hoisted_28 = { class: "card-body d-flex flex-column p-0" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", {
  class: "overlay-wrapper flex-grow-1 bgi-no-repeat bgi-size-cover bgi-position-center card-rounded",
  style: {"background-image":"url('media/stock/600x400/img-23.jpg')"}
}, null, -1)
const _hoisted_30 = { class: "overlay-layer bg-white bg-opacity-50" }
const _hoisted_31 = /*#__PURE__*/_createTextVNode("Explore")
const _hoisted_32 = { class: "col-sm-6" }
const _hoisted_33 = { class: "card card-custom card-stretch overlay mb-5 shadow-none min-h-250px" }
const _hoisted_34 = { class: "card-body d-flex flex-column p-0" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", {
  class: "overlay-wrapper flex-grow-1 bgi-no-repeat bgi-size-cover bgi-position-center card-rounded",
  style: {"background-image":"url('media/stock/600x400/img-11.jpg')"}
}, null, -1)
const _hoisted_36 = { class: "overlay-layer bg-white bg-opacity-50" }
const _hoisted_37 = /*#__PURE__*/_createTextVNode("Explore")
const _hoisted_38 = /*#__PURE__*/_createElementVNode("h3", { class: "text-dark fw-bolder fs-1 mb-6" }, "Framework Users", -1)
const _hoisted_39 = { class: "pb-10" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("h3", { class: "text-dark fw-bolder fs-1 mb-6" }, "Tutorials", -1)
const _hoisted_41 = { class: "card card-custom" }
const _hoisted_42 = { class: "card-body pt-2" }
const _hoisted_43 = { class: "d-flex mb-6" }
const _hoisted_44 = { class: "me-1" }
const _hoisted_45 = { class: "svg-icon svg-icon-sm svg-icon-primary" }
const _hoisted_46 = { class: "d-flex flex-column" }
const _hoisted_47 = /*#__PURE__*/_createTextVNode(" How to Create Your First Project with Start Admin Theme ")
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold text-muted" }, " But nothing can prepare you for the real thing ", -1)
const _hoisted_49 = { class: "d-flex mb-6" }
const _hoisted_50 = { class: "me-1" }
const _hoisted_51 = { class: "svg-icon svg-icon-sm svg-icon-primary" }
const _hoisted_52 = { class: "d-flex flex-column" }
const _hoisted_53 = /*#__PURE__*/_createTextVNode(" Start Admin Theme Getting Started & Installation ")
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold text-muted" }, " Long before you sit down to put digital pen ", -1)
const _hoisted_55 = { class: "d-flex mb-6" }
const _hoisted_56 = { class: "me-1" }
const _hoisted_57 = { class: "svg-icon svg-icon-sm svg-icon-primary" }
const _hoisted_58 = { class: "d-flex flex-column" }
const _hoisted_59 = /*#__PURE__*/_createTextVNode(" Craft a headline that is both informative and will capture ")
const _hoisted_60 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold text-muted" }, " But nothing can prepare you for the real thing ", -1)
const _hoisted_61 = { class: "d-flex mb-6" }
const _hoisted_62 = { class: "me-1" }
const _hoisted_63 = { class: "svg-icon svg-icon-sm svg-icon-primary" }
const _hoisted_64 = { class: "d-flex flex-column" }
const _hoisted_65 = /*#__PURE__*/_createTextVNode(" Write your post, either writing a draft in a single ")
const _hoisted_66 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold text-muted" }, " Long before you sit down to put pen ", -1)
const _hoisted_67 = { class: "d-flex mb-6" }
const _hoisted_68 = { class: "me-1" }
const _hoisted_69 = { class: "svg-icon svg-icon-sm svg-icon-primary" }
const _hoisted_70 = { class: "d-flex flex-column" }
const _hoisted_71 = /*#__PURE__*/_createTextVNode(" Use images to enhance your post, improve its flow ")
const _hoisted_72 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold text-muted" }, " Long before you sit down to put digital pen ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ListWidget1 = _resolveComponent("ListWidget1")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Close.svg" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _hoisted_18,
                          _createElementVNode("div", _hoisted_19, [
                            _createVNode(_component_router_link, {
                              to: "/shop1",
                              class: "btn btn-sm fw-bold btn-primary modal-link"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_20
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _hoisted_23,
                          _createElementVNode("div", _hoisted_24, [
                            _createVNode(_component_router_link, {
                              to: "/shop1",
                              class: "btn btn-sm fw-bold btn-primary modal-link"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_25
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, [
                          _hoisted_29,
                          _createElementVNode("div", _hoisted_30, [
                            _createVNode(_component_router_link, {
                              to: "/shop1",
                              class: "btn btn-sm fw-bold btn-primary modal-link"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_31
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _hoisted_35,
                      _createElementVNode("div", _hoisted_36, [
                        _createVNode(_component_router_link, {
                          to: "/shop1",
                          class: "btn btn-sm fw-bold btn-primary modal-link"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_37
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", null, [
              _hoisted_38,
              _createVNode(_component_ListWidget1)
            ]),
            _createElementVNode("div", _hoisted_39, [
              _hoisted_40,
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("div", _hoisted_44, [
                      _createElementVNode("span", _hoisted_45, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Angle-right.svg" })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_46, [
                      _createVNode(_component_router_link, {
                        to: "/faq",
                        class: "fs-6 fw-bolder text-hover-primary text-gray-800 mb-2 modal-link"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_47
                        ]),
                        _: 1
                      }),
                      _hoisted_48
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_49, [
                    _createElementVNode("div", _hoisted_50, [
                      _createElementVNode("span", _hoisted_51, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Angle-right.svg" })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_52, [
                      _createVNode(_component_router_link, {
                        to: "faq",
                        class: "fs-6 fw-bolder text-hover-primary text-gray-800 mb-2 modal-link"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_53
                        ]),
                        _: 1
                      }),
                      _hoisted_54
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_55, [
                    _createElementVNode("div", _hoisted_56, [
                      _createElementVNode("span", _hoisted_57, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Angle-right.svg" })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_58, [
                      _createVNode(_component_router_link, {
                        to: "/faq",
                        class: "fs-6 fw-bolder text-hover-primary text-gray-800 mb-2 modal-link"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_59
                        ]),
                        _: 1
                      }),
                      _hoisted_60
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_61, [
                    _createElementVNode("div", _hoisted_62, [
                      _createElementVNode("span", _hoisted_63, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Angle-right.svg" })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_64, [
                      _createVNode(_component_router_link, {
                        to: "/faq",
                        class: "fs-6 fw-bolder text-hover-primary text-gray-800 mb-2 modal-link"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_65
                        ]),
                        _: 1
                      }),
                      _hoisted_66
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_67, [
                    _createElementVNode("div", _hoisted_68, [
                      _createElementVNode("span", _hoisted_69, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Angle-right.svg" })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_70, [
                      _createVNode(_component_router_link, {
                        to: "/faq",
                        class: "fs-6 fw-bolder text-hover-primary text-gray-800 mb-2 modal-link"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_71
                        ]),
                        _: 1
                      }),
                      _hoisted_72
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ], 512))
}